import { Stack } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "./notifications_empty_state.module.scss";

export const NotificationsEmptyState = () => {
  const { t } = useTranslation("translation");

  return (
    <Stack className={css.noItemsToShow} center>
      <Icon name="missing" size="md" />
      <Typography withMargin variant="labelRegular">
        {t("notifications.noItemsToShow")}
      </Typography>
    </Stack>
  );
};
